import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetProjectListAction,
  toogleFavroiteAction,
} from "store/actions/ProjectActions";
import { GetContractListAction } from "store/actions/ContractActions";
import { Toast } from "primereact/toast";
import { useRef } from "react";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useNavigate();
  const [originalProjects, setOriginalProjects] = useState([]);
  const [displayedProjects, setDisplayedProjects] = useState([]);
  const [contract, setContract] = useState([]);
  const [count, setCount] = useState(0);
  const [statusCount, setStatusCount] = useState(0);
  const toast = useRef(null);

  const { profile } = useSelector((state) => state?.user);

  const sortWithFavoritesFirst = (projects) => {
    const sorted = [...projects];

    sorted.sort((a, b) => {
      if (a.isFavoriote === b.isFavoriote) return 0;

      return a.isFavoriote ? -1 : 1;
    });

    return sorted;
  };

  useEffect(() => {
    GetProjectListAction(
      10,
      1,
      "",
      () => {},
      dispatch,
      (result) => {
        setOriginalProjects(result.list);
        setDisplayedProjects(sortWithFavoritesFirst(result.list));
        setCount(result.count);
      }
    )();
  }, [dispatch]);

  useEffect(() => {
    GetContractListAction(
      10,
      1,
      "",
      () => {},
      dispatch,
      (res) => {
        setContract(res?.list);
        setCount(res?.count);
        setStatusCount(res?.statusCounts);
      }
    )();
  }, [dispatch]);

  const handleToggleFavorite = async (projectId) => {
    const projectIndex = originalProjects.findIndex((p) => p._id === projectId);
    if (projectIndex === -1) return;

    // Create new arrays for both states
    const newOriginalProjects = [...originalProjects];
    const newDisplayedProjects = [...displayedProjects];

    newOriginalProjects[projectIndex] = {
      ...newOriginalProjects[projectIndex],
      isFavoriote: !newOriginalProjects[projectIndex].isFavoriote,
    };

    const displayedIndex = newDisplayedProjects.findIndex(
      (p) => p._id === projectId
    );
    if (displayedIndex !== -1) {
      newDisplayedProjects[displayedIndex] = {
        ...newDisplayedProjects[displayedIndex],
        isFavoriote: !newDisplayedProjects[displayedIndex].isFavoriote,
      };
    }

    setOriginalProjects(newOriginalProjects);
    setDisplayedProjects(sortWithFavoritesFirst(newDisplayedProjects));

    try {
      await toogleFavroiteAction(
        { projectId },
        () => {},
        navigate,
        dispatch,
        () => {
          GetProjectListAction(
            10,
            1,
            "",
            () => {},
            dispatch,
            (result) => {
              setOriginalProjects(result.list);
              setDisplayedProjects(sortWithFavoritesFirst(result.list));
              setCount(result.count);
            }
          )();
        }
      )();
    } catch (error) {
      setOriginalProjects((prev) => [...originalProjects]);
      setDisplayedProjects((prev) =>
        sortWithFavoritesFirst([...originalProjects])
      );

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update favorite status",
        life: 3000,
      });
    }
  };

  const getProjectType = (projectType) => {
    switch (projectType) {
      case "SINGLE":
        return "Single";
      case "EP":
        return "EP";
      case "ALBUM":
        return "Album";
      default:
        return projectType;
    }
  }

  const getStatusText = (status) => {
    switch (status) {
      case "IN_PROGRESS":
        return "In Progress";
      case "NOT_STARTED":
        return "Not Started";
      case "COMPLETED":
        return "Completed";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "bg-green-500";
      case "IN_PROGRESS":
        return "bg-yellow-500";
      case "NOT_STARTED":
        return "bg-gray-500";
      default:
        return "bg-gray-500";
    }
  };

  const getProgressValue = (status) => {
    switch (status) {
      case "COMPLETED":
        return 100;
      case "IN_PROGRESS":
        return 50;
      case "NOT_STARTED":
        return 0;
      default:
        return 0;
    }
  };

  const getProgressColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "#4CAF50";
      case "IN_PROGRESS":
        return "#9E9E9E";
      case "NOT_STARTED":
        return "#9E9E9E";
      default:
        return "#9E9E9E";
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div>
        <h2 className="capitalize mb-3">
          Welcome back, {profile?.fullName || "User"}!
        </h2>
        <p className="opacity-50 color-black">
          Here are your projects, at a glance.
        </p>
      </div>
      <div className="mt-4 md:mt-6 pt-1 karla pb-2 flex align-items-center justify-content-between ">
        <h3>Overview: Project Management</h3>
        <Button
          label="View all"
          link
          onClick={() => navigate("/project-management")}
          className="p-0 underline text-base lg:text-lg color-grey text-right font-medium"
        />
      </div>
      {displayedProjects?.length === 0 && (
        <p className="text-lg text-gray-700 mt-2">
          No project is available right now.
        </p>
      )}
      <div className="mt-5 karla gap-3 xl:gap-5 card-block">
        {displayedProjects?.slice(0, 3).map((project, index) => (
          <div className="card" key={project._id || index}>
            <h4 className="color-verdigris capitalize mb-5 pb-1 flex justify-content-between">
              {project.projectName}
              <i
                className={`pi ${
                  project.isFavoriote ? "pi-star-fill" : "pi-star"
                } text-xl ${
                  project.isFavoriote ? "text-yellow-500" : "text-gray-400"
                } cursor-pointer`}
                onClick={() => handleToggleFavorite(project._id)}
              ></i>
            </h4>
            <p className="text-lg color-sycamore mb-5 font-bold">{getProjectType(project.projectType)}</p>
            <p className="m-0 color-sidebar text-lg capitalize flex align-items-center gap-3 mb-5">
              Status:
              <a
                rel="noopener noreferrer"
                className={`p-button border-0 py-1 px-2 line-height-2 font-bold text-sm ${getStatusColor(
                  project.projectStatus
                )}`}
              >
                {getStatusText(project.projectStatus)}
              </a>
            </p>
            <p className="m-0 color-sidebar text-lg capitalize flex align-items-center gap-3">
              Progress:
            </p>
            <ProgressBar
              value={getProgressValue(project.projectStatus)}
              className="mt-3 text-xs"
              style={{
                backgroundColor: getProgressColor(project.projectStatus),
              }}
            ></ProgressBar>

            <div className="text-center">
              <Button
                label="View"
                link
                onClick={() =>
                  navigate("/project-management", {
                    state: { id: project._id },
                  })
                }
                className="p-0 mt-5 underline text-base lg:text-lg color-sidebar text-right font-medium"
              />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 md:mt-6 pt-1 karla pb-2 flex align-items-center justify-content-between ">
        <h3>Contract Management</h3>
      </div>
      <div className="mt-5 karla gap-3 xl:gap-5 card-block management">
        <div className="card flex flex-column border-2 p-0">
          <div className="top-layer img-cover"></div>
          <div className="card-data flex flex-column h-full">
            <div className="mb-auto">
              <h3>Track Contracts</h3>
              <div className="divider mercury-bg w-full"></div>
              <h3 className="flex align-items-center justify-content-between mb-4 font-normal">
                Draft<span>{statusCount?.notStarted || 0}</span>
              </h3>
              <h3 className="flex align-items-center justify-content-between mb-4 font-normal">
                Sent<span>{statusCount?.sent || 0}</span>
              </h3>
              <h3 className="flex align-items-center justify-content-between mb-4 font-normal">
                Complete<span>{statusCount?.completed || 0}</span>
              </h3>
            </div>
            <div className="text-center">
              <Button
                label="View"
                link
                onClick={() => navigate("/project-management")}
                className="p-0 mt-3 underline text-base lg:text-lg color-sidebar text-right font-medium"
              />
            </div>
          </div>
        </div>
        <div className="card flex flex-column border-2 p-0">
          <div className="top-layer img-cover"></div>
          <div className="card-data flex flex-column h-full">
            <div className="mb-auto">
              <h3>Review & Sign</h3>
              <div className="divider mercury-bg w-full"></div>
              <h3 className="flex align-items-center justify-content-between mb-4 font-normal">
                To review & Sign<span>0</span>
              </h3>
              <h3 className="flex align-items-center justify-content-between mb-4 font-normal">
                Complete<span>{statusCount?.completed || 0}</span>
              </h3>
            </div>
            <div className="text-center">
              <Button
                label="View"
                link
                onClick={() => navigate("/contract-review")}
                className="p-0 mt-3 underline text-base lg:text-lg color-sidebar text-right font-medium"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
